/** Async Clipboard API 가 막힌 비-secure context·앱 WebView·구형 브라우저용 폴백. */
const copyWithExecCommand = (text: string): void => {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  // 포커스/스크롤 점프를 막기 위해 화면 밖에 배치
  textArea.style.position = 'fixed';
  textArea.style.top = '0';
  textArea.style.left = '-9999px';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    const succeeded = document.execCommand('copy');
    if (!succeeded) {
      throw new Error("execCommand('copy') 가 실패했습니다.");
    }
  } finally {
    document.body.removeChild(textArea);
  }
};

/**
 * Async Clipboard API 를 우선 시도하고, 실패하면 textarea + execCommand 폴백으로 재시도한다.
 * 모든 경로가 실패하면 reject 하므로 실패 처리는 호출부에서 한다.
 */
export const copyToClipboard = async (text: string): Promise<void> => {
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch {
      // Async Clipboard API 실패 시 execCommand 폴백으로 진행
    }
  }

  copyWithExecCommand(text);
};
